/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Land_Size_SqmInputs */

const en_field_land_size_sqm = /** @type {(inputs: Field_Land_Size_SqmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Land Size`)
};

const es_field_land_size_sqm = /** @type {(inputs: Field_Land_Size_SqmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tamaño del terreno`)
};

const fr_field_land_size_sqm = /** @type {(inputs: Field_Land_Size_SqmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taille du terrain`)
};

const de_field_land_size_sqm = /** @type {(inputs: Field_Land_Size_SqmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grundstücksgröße`)
};

const ja_field_land_size_sqm = /** @type {(inputs: Field_Land_Size_SqmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`敷地面積`)
};

const zh_field_land_size_sqm = /** @type {(inputs: Field_Land_Size_SqmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`土地面积`)
};

const ar_field_land_size_sqm = /** @type {(inputs: Field_Land_Size_SqmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مساحة الأرض`)
};

const id_field_land_size_sqm = /** @type {(inputs: Field_Land_Size_SqmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luas Tanah`)
};

const it_field_land_size_sqm = /** @type {(inputs: Field_Land_Size_SqmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dimensioni Terreno`)
};

const ru_field_land_size_sqm = /** @type {(inputs: Field_Land_Size_SqmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Размер участка`)
};

const pt_field_land_size_sqm = /** @type {(inputs: Field_Land_Size_SqmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tamanho do Terreno`)
};

const ko_field_land_size_sqm = /** @type {(inputs: Field_Land_Size_SqmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`대지 면적`)
};

/**
* | output |
* | --- |
* | "Land Size" |
*
* @param {Field_Land_Size_SqmInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_land_size_sqm = /** @type {((inputs?: Field_Land_Size_SqmInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Land_Size_SqmInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_land_size_sqm(inputs)
	if (locale === "es") return es_field_land_size_sqm(inputs)
	if (locale === "fr") return fr_field_land_size_sqm(inputs)
	if (locale === "de") return de_field_land_size_sqm(inputs)
	if (locale === "ja") return ja_field_land_size_sqm(inputs)
	if (locale === "zh") return zh_field_land_size_sqm(inputs)
	if (locale === "ar") return ar_field_land_size_sqm(inputs)
	if (locale === "id") return id_field_land_size_sqm(inputs)
	if (locale === "it") return it_field_land_size_sqm(inputs)
	if (locale === "ru") return ru_field_land_size_sqm(inputs)
	if (locale === "pt") return pt_field_land_size_sqm(inputs)
	return ko_field_land_size_sqm(inputs)
});